import { Typography } from 'antd';
import { ChevronRight } from 'lucide-react';

const { Title } = Typography;

export function HowItWorks() {
  const steps = [
    'Platform Admin',
    'Creates Plans',
    'Tenant Company',
    'Configures Features',
    'Publishes Widget',
    'Users Subscribe',
    'Access Granted',
    'Usage Tracked',
  ];

  return (
    <section style={{ padding: '80px 24px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            How It Works
          </Title>
        </div>

        <div className="how-it-works-container">
          {steps.map((step, i) => (
            <div key={step} className="step-item">
              <div className="step-card">
                <div className="step-circle">{i + 1}</div>
                <div className="step-text">{step}</div>
              </div>
              {i < steps.length - 1 && (
                <ChevronRight size={20} className="step-chevron" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
